import { Stack } from '@mui/material'
import { t } from 'i18next'
import { useEffect, useRef, useState } from 'react'

import Filter from '../../Layout/Dialogs/Filter.jsx'
import { useAuth } from '../../Shared/Contexts/AuthContext.jsx'
import OrganizationsFilter from '../../Shared/Filters/Fields/OrganizationsFilter.jsx'

const Filters = ({ filters, onChange, itemsCount }) => {
  const [selectedOrganizations, setSelectedOrganizations] = useState(false)
  const [announcementUpdatePage, setAnnouncementUpdatePage] = useState('')
  const shouldAnnounceUpdatePage = useRef(false)
  const previousItemsCount = useRef(itemsCount)

  const {
    currentUser: { isSuperAdmin, currentOrganizationKey, permissions }
  } = useAuth()

  const orgPermissions =
    currentOrganizationKey && permissions
      ? permissions[currentOrganizationKey] || []
      : []

  const handleOnDeleteOrganizations = () => {
    setSelectedOrganizations(false)
    onChange({
      ...filters,
      organizationKeys: []
    })
    shouldAnnounceUpdatePage.current = true
  }

  const handleOrganizationsChange = (data) => {
    setSelectedOrganizations(true)
    onChange({
      ...filters,
      ...data
    })
  }

  const handleFilterClose = () => {
    shouldAnnounceUpdatePage.current = true
    announceUpdatePage()
  }

  const getAnnouncementMessage = () => {
    return 'Pagina aggiornata'
  }

  const announceUpdatePage = () => {
    setAnnouncementUpdatePage('')

    setTimeout(() => {
      setAnnouncementUpdatePage(getAnnouncementMessage())
    }, 100)
  }

  useEffect(() => {
    if (shouldAnnounceUpdatePage.current && previousItemsCount.current !== itemsCount) {
      announceUpdatePage()
      shouldAnnounceUpdatePage.current = false
    }
    previousItemsCount.current = itemsCount
  }, [itemsCount])

  useEffect(() => {
    const { organizationKeys } = filters

    setSelectedOrganizations(
      !!(organizationKeys && organizationKeys.length > 0)
    )
  }, [filters])

  const filterUnits = [
    {
      label: t('filters.devices.organizations.label'),
      id: 'chip-filters-statistics-organizations',
      selected: selectedOrganizations,
      onDelete: handleOnDeleteOrganizations,
      onClose: handleFilterClose,
      hidden: !orgPermissions.includes('organizations_r') && !isSuperAdmin,
      content: (
        <OrganizationsFilter
          filters={filters}
          onChange={handleOrganizationsChange}
          enableSearchInSubOrganizations={false}
        />
      )
    }
  ]

  return (
    <>
      {/* Live region per annunci screen reader */}
      <div
        role="status"
        aria-live="polite"
        aria-atomic="true"
        style={{
          position: 'absolute',
          left: '-10000px',
          width: '1px',
          height: '1px',
          overflow: 'hidden'
        }}
      >
        {announcementUpdatePage}
      </div>
      <Stack
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        spacing={2}
      >
        {[...filterUnits].map((e, i) => (
          <Filter
            key={`device-filter-${i}`}
            id={e.id}
            onClick={e.onClick}
            onDelete={e.onDelete}
            selected={e.selected}
            onClose={e.onClose}
            title={e.label}
            hidden={e.hidden || false}
            content={e.content}
            count={e.count}
          />
        ))}
      </Stack>
    </>
  )
}

export default Filters
